import { UserPreferencesState, RootState, UserPreferencesMutationTypes, DocumentToStoreTargetDocumentTypeModel, StoreConstants } from '@/types';
import { ActionTree } from 'vuex';

export const actions: ActionTree<UserPreferencesState[], RootState> = {
  setJobVerticalSlider({ commit, rootState }, workflowJobPreference) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetJobVerticalSlider, { userId, workflowJobPreference });
  },

  setWorkflowTreeView({ commit, rootState }, workflowTreeView) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetWorkflowTreeView, { userId, workflowTreeView });
  },

  setCanGetNextJob({ commit, rootState }, workflowJobPreference) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetCanGetNextJob, { userId, workflowJobPreference });
  },

  setSelectedWorkFlowQueueId({ commit, rootState }, selectedQueueId) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetLastSelectedWorkflowQueue, { userId, selectedQueueId });
  },

  setUserPreferedWorkflowQueueTableOptions({ commit, rootState }, workflowQueueTableStatePreference) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetWorkflowQueueTableStateField, { userId, workflowQueueTableStatePreference });
  },

  setDocumentToStoreTargetDocumentType({ commit, rootState }, payload) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetDocumentToStoreTargetDocumentType, {
      userId,
      targetDocumentTypeModel: payload.targetDocumentTypeModel,
      cabinetId: payload.cabinetId
    });
  },
  setDocumentToStoreCanGetNextDocument({ commit, rootState }, canGetNextDocument: boolean) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetDocumentToStoreCanGetNextDocument, { userId, canGetNextDocument });
  },
  setDocumentToStoreTargetDocumentTypeFromPreviousSelection({ commit, state, getters, rootState }, payload) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;

    const documentTypeSelection =
      getters.getDocumentToStoreDocumentTypeSelection(payload.targetDocumentTypeModel.sourceDocumentType, payload.cabinetId) || payload.targetDocumentTypeModel.targetDocumentType;

    commit(UserPreferencesMutationTypes.SetDocumentToStoreTargetDocumentType, {
      userId,
      targetDocumentTypeModel: {
        sourceDocumentType: payload.targetDocumentTypeModel.sourceDocumentType,
        targetDocumentType: documentTypeSelection
      } as DocumentToStoreTargetDocumentTypeModel,
      cabinetId: payload.cabinetId
    });
  },

  removeDocumentTypeSelection({ commit, rootState }, payload) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.RemoveDocumentTypeSelection, {
      userId,
      documentTypeId: payload.documentTypeId,
      sourceDocumentType: payload.sourceDocumentType
    });
  },

  setPinFilter({ commit, rootState }, workflowJobPreference) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetPinFilter, { userId, workflowJobPreference });
  },

  setIsHorizontalTabUp({ commit, rootState }, horizontalTabVisibility) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetIsHorizontalTabUp, { userId, horizontalTabVisibility });
  },

  updateVuexPersistedState({ commit }) {
    commit(UserPreferencesMutationTypes.UpdateVuexPersistedState);
  },
  addSuppressedConfirmation({ commit, rootState }, payload) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.AddSuppressedConfirmation, { userId, key: payload });
  },
  setDocumentsToStoreTableSortProperties({ commit, rootState }, payload) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetDocumentsToStoreTableSortProperties, { userId, key: payload });
  },
  removeSuppressedConfirmation({ commit, rootState }, payload) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.RemoveSuppressedConfirmation, { userId, key: payload });
  },
  setDocumentsToStoreVerticalSlider({ commit, rootState }, documentsToStorePreference) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetDocumentsToStoreVerticalSlider, { userId, documentsToStorePreference });
  },
  setDocumentToStoreTableFilters({ commit, rootState }, tableFilters) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(UserPreferencesMutationTypes.SetDocumentToStoreTableFilters, { userId, tableFilters });
  },
  [StoreConstants.UserPreferences.Actions.SetSortOptions]({ commit, rootState }, { queueId, sortOptions }) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.UserPreferences.Mutations.SetSortOptions, { userId, queueId, sortOptions });
  },
  [StoreConstants.UserPreferences.Actions.SetFilterOptions]({ commit, rootState }, { queueId, filterOptions }) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.UserPreferences.Mutations.SetFilterOptions, { userId, queueId, filterOptions });
  },
  [StoreConstants.UserPreferences.Actions.SetPinSort]({ commit, rootState }, { queueId, pinSort }) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.UserPreferences.Mutations.SetPinSort, { userId, queueId, pinSort });
  },
  [StoreConstants.UserPreferences.Actions.SetPagesStoreMode]({ commit, rootState }, { pagesStoreMode }) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.UserPreferences.Mutations.SetPagesStoreMode, { userId, pagesStoreMode });
  },
  [StoreConstants.UserPreferences.Actions.SetColumnConfigurations]({ commit, rootState }, { queueId, columnConfigurations }) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.UserPreferences.Mutations.SetColumnConfigurations, { userId, queueId, columnConfigurations });
  },
  [StoreConstants.UserPreferences.Actions.SetEmailToMe]({ commit, rootState }, { convertToPdf, dontAskAgain }) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.UserPreferences.Mutations.SetEmailToMe, { userId, convertToPdf, dontAskAgain });
  },
  [StoreConstants.UserPreferences.Actions.SetSearchOptions]({ commit, rootState }, { cabinets, documentTypes }) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.UserPreferences.Mutations.SetSearchOptions, { userId, cabinets, documentTypes });
  },
  [StoreConstants.UserPreferences.Actions.SetIncludeDocumentContent]({ commit, rootState }, includeDocumentContent) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.UserPreferences.Mutations.SetIncludeDocumentContent, { userId, includeDocumentContent });
  },
  [StoreConstants.UserPreferences.Actions.SetSearchPinSort]({ commit, rootState }, { pinSort }) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.UserPreferences.Mutations.SetSearchPinSort, { userId, pinSort });
  },
  [StoreConstants.UserPreferences.Actions.SetSearchPinFilter]({ commit, rootState }, { pinFilter }) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.UserPreferences.Mutations.SetSearchPinFilter, { userId, pinFilter });
  },
  [StoreConstants.UserPreferences.Actions.SetSearchSplitConfiguration]({ commit, rootState }, { splitConfiguration }) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.UserPreferences.Mutations.SetSearchSplitConfiguration, { userId, splitConfiguration });
  }
};
